import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { updateApInvoices, getApInvoicesById, cleanApInvoicesById } from '@store/Finance/AP/ApInvoices/ApInvoicesSlice';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import { TreeSelect } from 'antd';
import useGetPaymentTermsList from '@hooks/Sales/useGetPaymentTermsList';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import ApPaymentSchedules from './ApPaymentSchedules';
import ApInvoiceLines from './ApInvoiceLines';
import { AddApInvoiceSchema } from '../../../ValidationForm/validationSchema';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useGetUnApplyPrepayments from '@hooks/Finance/ApPayments/useGetUnApplyPrepayments';
import useGetCodeCombination from '@hooks/Finance/ChartAccountsDetails/useGetCodeCombination';
import { type UnApplyPrepaymentsModels } from '@store/Finance/AP/ApPayments/ApPaymentsModels';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '../../Journals/JournalsByReference/JournalsByReference';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { activeFinanceSelector } from '@store/Login/authSelectors';
import ViewPO from './ViewPurchaseOrder/ViewPO';
import ApExpenseForm from '../ApExpense/ApExpenseForm';
import ButtonPrint from '@components/Print/ButtonPrint';

const UpdateApInvoice = () => {
  const activeFinance = useAppSelector(activeFinanceSelector);
  const [showReferenceDetails, setShowReferenceDetails] = useState(false);

  const [show, setShow] = useState(false);
  const { IdInvoices } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { Currency, loading: loading1, error: error1 } = useLookupCurrency();

  const { OperatingUnitOptions, loading: loading7, error: error7 } = useGetOperatingUnitWithPermission();
  const { treeSuppliersData, loading: loading3, error: error3 } = useGetSuppliersList();
  const { PaymentTermsList, loading: loading4, error: error4 } = useGetPaymentTermsList();
  const { PaymentMethodList, loading: loading5, error: error5 } = useGetPaymentMethod();
  const { GetCodeCombination, loading: loading6, error: error6 } = useGetCodeCombination();

  useEffect(() => {
    if (IdInvoices) {
      dispatch(getApInvoicesById(IdInvoices));
    }
    return () => {
      dispatch(cleanApInvoicesById());
    };
  }, [IdInvoices]);

  const { ApInvoicesById: data, loadingById: loading, errorById: error } = useAppSelector(a => a.ApInvoices);

  // console.log(data);

  // تحديد إذا كانت الفاتورة مرحلة
  const isPosted = data?.postedFlag === true;
  // التحقق من نوع المرجع
  const hasPurchaseOrder = ['Bill_NonInventory', 'Bill'].includes(data?.referenceType); // فاتورة مشتريات
  const hasExpenses = ['EXP', 'EXP_FAST'].includes(data?.referenceType); // مصروفات
  const hasDebitMemo = data?.referenceType === 'DebitMemo'; // مردود مشتريات
  const hasDiscount = data?.referenceType === 'Discount'; // خصم امر شراء ..
  // فلاج منع التعديل
  const NotEditable = hasPurchaseOrder || hasExpenses || hasDebitMemo || isPosted;

  // console.log(data.apInvoiceLinesList);

  //#region Formik
  const formik = useFormik({
    initialValues: {
      invoiceNum: data.invoiceNum ?? '',
      peopleId: data.peopleId ?? '',
      invoiceType: data.invoiceType ?? '',
      referenceType: data.referenceType ?? '',
      referenceId: data.referenceId ?? '',
      invoiceDate: data.invoiceDate?.split('T')[0] ?? '',
      organizationId: data.organizationId ?? '',
      paymentTermsId: data.paymentTermsId ?? '',
      paymentMethodId: data.paymentMethodId ?? '',
      currencyCode: data.currencyCode ?? '',
      currencyConversionRate: data.currencyConversionRate ?? '',
      includeVatFlag: data.includeVatFlag ?? false,
      postedFlag: data.postedFlag ?? false,

      apInvoiceLinesList:
        data.apInvoiceLinesList?.map(item => ({
          id: item.id,
          lineNumber: item.lineNumber,
          lineType: item.lineType,
          invItemId: item.invItemId,
          uom: item.uom,
          description: item.description,
          price: item.price,
          qty: item.qty,
          discountRate: item.discountRate,
          discountAmount: item.discountAmount,
          vatRate: item.vatRate,
          total: item.total,
          vatAmount: item.vatAmount,
          currencyCode: data.currencyCode ?? '',
          currencyConversionRate: data.currencyConversionRate ?? '',
          purHeaderId: item.purHeaderId ?? null,
          purLineId: null,
          accountId: item.accountId,
          costCenterId: item.costCenterId,
          branchId: item.glBrunchId,
          companyId: item.glCompanyId,

          // branchId: GetGlBrancheId(data.organizationId),
          // companyId: GlCompanyId,
          //
          codeCombination: GetCodeCombination(item.glCompanyId, item.glBrunchId, item.accountId, item.costCenterId)
        })) ?? [],
      apPaymentSchedulesList:
        data.apPaymentSchedulesList?.map(item => ({
          id: item.id,
          amount: item.amount,
          dueDate: item.dueDate?.split('T')[0],
          paymentId: item.paymentId,
          invoicePaymentId: item.invoicePaymentId,

          paymentCode: item.codePayment, // رقم الدفعة
          paymentDate: new Date(item.paymentDate).toLocaleDateString(), // تريخ الدقعة
          paymentAmount: item.amountPayment,
          // ~~ الحقول ادناة في حال كانت الدفعة عادية (غير مقدمة) وهي للعرض فقط ~~~~~~~
          AmountPaid: item.paymentId === null ? item.amountPayment : 0, // المبلغ المدفوع
          RemainingAmount: item.paymentId === null ? item.amount - item.amountPayment : 0 // المبلغ المتبقي
        })) ?? []
    },

    enableReinitialize: true,
    validationSchema: AddApInvoiceSchema(t, activeFinance),
    onSubmit: values => {
      // منع التعديل إذا كانت الفاتورة مرحلة
      if (isPosted) {
        CustomAlert({ action: 'info', msg: t('لا يمكن تعديل الفواتير بعد الترحيل') });
        formik.setSubmitting(false);
        return;
      }

      const { apInvoiceLinesList, apPaymentSchedulesList } = values;

      if (apInvoiceLinesList?.length === 0) {
        SwalAlert({ text: 'لا يمكن متابعة العملية بدون إضافة بنود للفاتورة، يرجى إضافة البنود.' });
        formik.setSubmitting(false);
        return;
      }

      const totalInvoiceLines = apInvoiceLinesList?.reduce((sum: number, item: any) => sum + item.total, 0);
      const totalPaymentSchedules = apPaymentSchedulesList?.reduce(
        (sum: number, payment: any) => sum + Number(payment.amount),
        0
      );

      const round2 = (n: number) => Math.round(n * 100) / 100;
      if (apPaymentSchedulesList?.length > 0 && round2(totalInvoiceLines) !== round2(totalPaymentSchedules)) {
        SwalAlert({ text: 'لا يتطابق مجموع الفاتورة مع مجموع الجدولة. يرجى المراجعة.' });
        formik.setSubmitting(false);
        return;
      }

      // if (apPaymentSchedulesList?.length > 0 && totalInvoiceLines !== totalPaymentSchedules) {
      //   SwalAlert({ text: 'لا يتطابق مجموع الفاتورة مع مجموع الجدولة. يرجى المراجعة.' });
      //   formik.setSubmitting(false);
      //   return;
      // }
      // debugger;
      dispatch(
        updateApInvoices({
          id: data.id,

          invoiceNum: values.invoiceNum,
          invoiceDate: values.invoiceDate,
          paymentTermsId: values.paymentTermsId,
          paymentMethodId: values.paymentMethodId,

          apInvoiceLinesList: values.apInvoiceLinesList?.map((line: any, idx) => ({
            id: line.id,

            lineNumber: ++idx,
            lineType: line.lineType,
            invItemId: line.invItemId,
            uom: line.uom || null,
            description: line.description,
            price: line.price || 0,
            qty: line.qty || 0,
            discountRate: line.discountRate || 0,
            discountAmount: line.discountAmount || 0,
            vatRate: line.vatRate || 0,
            total: line.total,
            vatAmount: line.vatAmount || 0,
            accountId: line.accountId,
            costCenterId: line.costCenterId,
            branchId: line.branchId,
            companyId: line.companyId
          })),
          apPaymentSchedulesList:
            values.apPaymentSchedulesList?.map((item: any) => ({
              id: item.id,
              amount: item.amount,
              dueDate: item.dueDate,
              paymentId: item.paymentId,

              invoicePaymentId: item.invoicePaymentId
            })) || null
        })
      )
        .unwrap()
        .then((res: any) => {
          // debugger;
          // console.log(res);

          if (res.succeeded) {
            CustomAlert({ action: 'Edit' });
            navigate('/AP/ApInvoices', { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res.message });
            formik.setSubmitting(false);
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });
  const { values, handleChange: formikhandleChange, errors, touched, setFieldValue } = formik;
  //#endregion

  const { hasPrepayments, totalPrepaymentAmount, UnApplyPrepaymentsList } = useGetUnApplyPrepayments({
    PeopleId: values.peopleId
  });

  // حساب المبلغ المتبقي للدفعة المقدمة إن وجدت
  useEffect(() => {
    const updatedPayments = formik.values.apPaymentSchedulesList.map(item => {
      const paymentAmountUnApply = item.paymentId
        ? (UnApplyPrepaymentsList?.find(f => f.id === item.paymentId)?.amountUnApply ?? 0)
        : 0;

      return {
        ...item,
        // PaymentAmountUnApply: paymentAmountUnApply,
        PaymentAmountUnApply: !isPosted ? paymentAmountUnApply + (item.amount ?? 0) : paymentAmountUnApply
        // يساوي المبلغ المبتقي + المبلغ المدخل سابقا
        // واذا كان قد رحلت الفاتورة يساوي المبلغ المتبقي فقط نظرا لأنه لا يستطيع التعديل
      };
    });

    formik.setFieldValue('apPaymentSchedulesList', updatedPayments);
  }, [UnApplyPrepaymentsList, isPosted]);

  // تحديث القيمة المتبقية من قائمة الدفعات المتبقية ان وجدت
  const [unApplyPrepayments, setUnApplyPrepayments] = useState<UnApplyPrepaymentsModels[]>([]);
  useEffect(() => {
    const updatedPrepayments = UnApplyPrepaymentsList?.map(prepayment => {
      const matchingItem = data?.apPaymentSchedulesList?.find(item => item.paymentId === prepayment.id);

      if (matchingItem) {
        const paymentAmountUnApply = matchingItem.paymentId ? (prepayment.amountUnApply ?? 0) : 0;

        // تعديل القيمة بناءً على paymentAmountUnApply و amount
        return {
          ...prepayment,
          amountUnApply: paymentAmountUnApply + (matchingItem.amount ?? 0)
        };
      }

      return prepayment;
    });

    // تعيين القائمة المعدلة
    setUnApplyPrepayments(updatedPrepayments);
  }, [UnApplyPrepaymentsList, data?.apPaymentSchedulesList]);

  // تحديد إعدادات Alert بناءً على النوع
  const getReferenceAlertConfig = () => {
    if (hasPurchaseOrder) {
      return {
        show: true,
        icon: 'fas fa-shopping-cart',
        title: t('فاتورة مرتبطة بأمر شراء'),
        message: t('هذه الفاتورة صادرة بناءً على أمر الشراء رقم'),
        referenceNumber: '000000',
        buttonText: t('عرض أمر الشراء'),
        alertClass: 'alert-warning'
      };
    } else if (hasExpenses) {
      return {
        show: true,
        icon: 'fas fa-money-bill-wave',
        title: t('فاتورة مصروفات'),
        message: t('هذه الفاتورة تمثل مصروفًا مسجلًا برقم المرجع'),
        referenceNumber: '000000',
        buttonText: t('عرض تفاصيل المصروف'),
        alertClass: 'alert-info'
      };
    } else if (hasDebitMemo) {
      return {
        show: true,
        icon: 'fas fa-undo-alt',
        title: t('إشعار خصم (مرتجع مشتريات)'),
        message: t('هذه الفاتورة تمثل إشعار خصم مرتبط بمرتجع المشتريات رقم'),
        referenceNumber: '000000',
        buttonText: t('عرض مرتجع المشتريات'),
        alertClass: 'alert-danger'
      };
    } else if (hasDiscount) {
      return {
        show: true,
        icon: 'fas fa-percent',
        title: t('إشعار خصم '),
        // message: t('إشعـــار خصــم'),
        // referenceNumber: '',
        buttonText: t(''),
        alertClass: 'alert-success'
      };
    }

    return {
      show: false,
      icon: '',
      title: '',
      message: '',
      referenceNumber: '',
      buttonText: '',
      alertClass: ''
    };
  };
  const referenceAlertConfig = getReferenceAlertConfig();

  // عرض المحتوى المناسب في المودال بناءً على النوع
  const renderModalContent = () => {
    if (hasPurchaseOrder && values.apInvoiceLinesList[0]?.purHeaderId) {
      return (
        <ViewPO
          purchaseOrderId={values.apInvoiceLinesList[0].purHeaderId}
          key={values.apInvoiceLinesList[0].purHeaderId}
        />
      );
    } else if (hasExpenses) {
      return (
        <>
          <ApExpenseForm
            isViewOnly
            // id={values.apInvoiceLinesList[0]?.purHeaderId}
            id={values.referenceId}
            key={values.apInvoiceLinesList[0]?.purHeaderId}
          />
        </>
      );
    } else if (hasDebitMemo) {
      return (
        <>
          <div className='d-flex flex-column align-items-center justify-content-center py-5'>
            <i className='fas fa-money-bill-wave fa-4x text-info mb-3'></i>
            <h4 className='text-muted'>تفاصيل مردود المشتريات</h4>
            <p className='text-muted'>رقم المرجع: {'00000'}</p>
            <p className='text-muted mt-2'> ... قيد التطوير ...</p>
          </div>
        </>
      );
    } else {
      return (
        <div className='d-flex flex-column align-items-center justify-content-center py-5'>
          <i className='fas fa-file-alt fa-4x text-muted mb-3'></i>
          <h4 className='text-muted'>لا توجد تفاصيل متاحة للعرض</h4>
          <p className='text-muted mt-2'>لا يوجد محتوى مرتبط بهذه الفاتورة</p>
        </div>
      );
    }
  };

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'PaymentInvoices',
              link: '/AP/ApInvoices'
            },
            {
              name: 'InvoiceDetails',
              link: null
            }
          ]}
          PageName='InvoiceDetails'
        />
        <div className='ms-auto'>
          <div className='col-5 col-md-6 text-end'>
            <ButtonPrint
              PrintTemplateTypeId='50430DE0-1BAA-4966-8FE6-8F45A395F116' // قوالب فواتيـر المدفوعات
              ReferenceId={data.id || ''}
            />
          </div>
        </div>
      </div>

      <Loading
        loading={loading || loading1 || loading7 || loading3 || loading4 || loading5 || loading5 || loading6}
        error={error || error1 || error7 || error3 || error4 || error5 || error6}
      >
        <Card>
          {isPosted && (
            <div className='alert alert-info d-flex align-items-center justify-content-between m-2'>
              <div className='d-flex align-items-center'>
                <i className='fas fa-info-circle fa-2x me-3'></i>
                <div>
                  <h5 className='mb-1'>{t('الفاتورة مرحلة')}</h5>
                  <p className='mb-0'>{t('لا يمكن تعديل الفواتير بعد ترحيلها في النظام')}</p>
                </div>
              </div>

              {/* الزر في الطرف الآخر */}
              <button type='button' className='btn btn-sm btn-info' onClick={() => setShow(true)}>
                <i className='fa fa-info-circle fa-fw me-1'></i>
                {t('عرض القيد')}
              </button>
            </div>
          )}

          {data.referenceType !== '' && (
            <div
              className={`alert ${referenceAlertConfig.alertClass} d-flex align-items-center justify-content-between m-2`}
              hidden={!referenceAlertConfig.show}
            >
              <div className='d-flex align-items-center'>
                <i className={`${referenceAlertConfig.icon} fa-2x me-3`}></i>
                <div>
                  <h5 className='mb-1'>{referenceAlertConfig.title}</h5>
                  <p className='mb-0'>
                    {referenceAlertConfig.message}
                    <span className='fw-bold text-primary mx-2'>{referenceAlertConfig.referenceNumber}</span>
                  </p>
                </div>
              </div>

              <button
                type='button'
                className={`btn btn-sm ${referenceAlertConfig.alertClass.replace('alert-', 'btn-')}`}
                onClick={() => setShowReferenceDetails(true)}
              >
                <i className='fa fa-eye fa-fw me-1'></i>
                {referenceAlertConfig.buttonText}
              </button>
            </div>
          )}

          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <div className='row'>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('InvoiceDate')}</label>
                    <Form.Control
                      disabled={isPosted}
                      className='form-control '
                      type='date'
                      name='invoiceDate'
                      onChange={formikhandleChange}
                      value={values.invoiceDate || ''}
                      isInvalid={!!(touched.invoiceDate && errors.invoiceDate)}
                    />

                    <div className='text-danger small'>{touched.invoiceDate && errors.invoiceDate}</div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('InvoiceType')} </label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='invoiceType'
                      onChange={formikhandleChange}
                      value={values.invoiceType || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      <option value='Standard'>{i18n.language === 'en' ? 'Standard' : 'قياسي'}</option>
                      <option value='CreditMemo'>{i18n.language === 'en' ? 'Debit Memo' : 'إشعار مدين'}</option>
                    </Form.Select>
                    <div className='text-danger small'>{touched.invoiceType && errors.invoiceType}</div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('OperatingUnit')}</label>

                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={false}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      // onChange={(option: any) => handleChangeOrganizationId(option)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Supplier')}</label>
                    <TreeSelect
                      disabled
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.peopleId}
                      onChange={option => {
                        formik.setFieldValue('peopleId', option === null ? null : option);
                      }}
                      treeData={treeSuppliersData}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger small'>{touched.peopleId && errors.peopleId}</div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group flex-nowrap mb-3'>
                    <label className='form-label'>{t('SupplierInvoiceNumber')}</label>

                    <div className='input-group flex-nowrap'>
                      <Form.Control
                        // disabled={isPosted}
                        disabled={NotEditable}
                        autoComplete='off'
                        className='form-control  text-center'
                        type='text'
                        name='invoiceNum'
                        onChange={formikhandleChange}
                        value={values.invoiceNum || ''}
                        isInvalid={!!(touched.invoiceNum && errors.invoiceNum)}
                      />
                    </div>
                    <div className='text-danger small'>{touched.invoiceNum && errors.invoiceNum}</div>
                  </div>
                </div>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PaymentTerms')}</label>
                    <Form.Select
                      disabled={isPosted}
                      className='form-select'
                      name='paymentTermsId'
                      onChange={formik.handleChange}
                      value={formik.values.paymentTermsId || ''}
                      // isInvalid={!!(formik.errors.paymentTermsId && formik.touched.paymentTermsId)}
                    >
                      <option value={''}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PaymentTermsList &&
                        PaymentTermsList?.map((item: any, idx: number) => (
                          <option key={++idx} value={item.id}>
                            {i18n.language === 'ar' ? item.name2 : item.name}
                          </option>
                        ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.paymentTermsId && errors.paymentTermsId}</div>
                  </div>
                </div>
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PaymentMethod')}</label>
                    <Form.Select
                      disabled={isPosted}
                      className='form-select'
                      name='paymentMethodId'
                      onChange={formik.handleChange}
                      value={formik.values.paymentMethodId || ''}
                      isInvalid={!!(formik.touched.paymentMethodId && formik.errors.paymentMethodId)}
                    >
                      <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                      {PaymentMethodList?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.paymentMethodId && errors.paymentMethodId}</div>
                  </div>
                </div>
                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Currency')} </label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='currencyCode'
                      onChange={formikhandleChange}
                      value={values.currencyCode}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                      {Currency &&
                        Currency?.map((item: any, idx: number) => (
                          <option key={++idx} value={item.currencyCode}>
                            {item.description}
                          </option>
                        ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
                  </div>
                </div>
                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('CurrencyConversionRate')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      autoComplete='off'
                      readOnly
                      value={values.currencyConversionRate || ''}
                    />
                    <div className='text-danger small'>
                      {touched.currencyConversionRate && errors.currencyConversionRate}
                    </div>
                  </div>
                </div>
              </div>

              <div className='alert alert-primary' hidden={!hasPrepayments || isPosted}>
                <i className='fas fa-lg fa-exclamation-circle me-2'></i>
                <strong> {t('Reminder')}</strong> {t('PrepaymentMessage')}
                <span className='ms-2 text-success  fw-bold fs-5'>{totalPrepaymentAmount}</span>
              </div>
            </CardBody>
            <CardFooter className='mt-2 mb-2 p-0'>
              <ul className='nav nav-tabs p-0'>
                <li className='nav-item  border-3 border-theme '>
                  <Link to='#apInvoiceLines' className='nav-link active' data-bs-toggle='tab'>
                    <i className='fas fa-file-invoice me-2 text-theme'></i>
                    {t('InvoiceLines')}
                  </Link>
                </li>
                <li className='nav-item  '>
                  <Link to='#apPaymentSchedules' className='nav-link' data-bs-toggle='tab'>
                    <i className='fas fa-calendar-alt me-2 text-theme'></i>
                    {t('InvoiceSchedule')}
                  </Link>
                </li>
              </ul>

              <div className='tab-content py-4 px-0'>
                <div className='tab-pane fade show active' id='apInvoiceLines'>
                  <ApInvoiceLines formik={formik} NotEditable={NotEditable || false} />
                </div>
                <div className='tab-pane fade' id='apPaymentSchedules'>
                  <ApPaymentSchedules
                    formik={formik}
                    UnApplyPrepaymentsList={unApplyPrepayments}
                    NotEditable={NotEditable || false}
                  />
                </div>
              </div>

              {formik.errors.apPaymentSchedulesList?.length && (
                <div className='text-danger'> {t('InvoiceScheduleRequired')}</div>
              )}

              <div className='text-center mt-2'>
                <button
                  disabled={formik.isSubmitting || isPosted}
                  type='submit'
                  className='btn btn-lg me-1 btn-theme mb-1'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fa fa-save fa-fw me-1'></i>
                  )}
                  {t('Save')}
                </button>
                <button
                  type='button'
                  className=' btn btn-lg me-1 btn-default mb-1'
                  onClick={() => navigate('/AP/ApInvoices', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </CardFooter>
          </Form>
        </Card>
      </Loading>
      <NeatixModal show={show} setShow={setShow} size='xl' title='تفاصيــل القيد'>
        {IdInvoices && <JournalsByReference referenceId={IdInvoices} />}
      </NeatixModal>

      <NeatixModal
        show={showReferenceDetails}
        setShow={setShowReferenceDetails}
        size='xl'
        showHeader={false}
        bodyClassName='p-0'
        centered
      >
        {showReferenceDetails ? renderModalContent() : null}
      </NeatixModal>
    </>
  );
};

export default UpdateApInvoice;
// <NeatixModal
//       show={showReferenceDetails}
//       setShow={setShowReferenceDetails}
//       size='xl'
//       showHeader={false}
//       bodyClassName='p-0'
//       centered
//     >
//       {values.apInvoiceLinesList[0]?.purHeaderId ? (
//         <ViewPO
//           purchaseOrderId={values.apInvoiceLinesList[0].purHeaderId}
//           key={values.apInvoiceLinesList[0].purHeaderId} // Add key for proper re-rendering
//         />
//       ) : (
//         <div className='d-flex flex-column align-items-center justify-content-center py-5'>
//           <i className='fs-1 text-muted mb-3'>📋</i>
//           <p className='text-muted mb-3'>لا يوجد أمر شراء متاح للعرض</p>
//           <button className='btn btn-outline-secondary' onClick={() => setShowReferenceDetails(false)}>
//             إغلاق
//           </button>
//         </div>
//       )}
//     </NeatixModal>
